import React, {useCallback, useState} from "react";
import {Button, FormControl, Modal, Table} from "react-bootstrap";
import {csrfHeader} from "./lib/utils";
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";

export const NgBuyersForm = params => {
    const {q, url, master} = params;
    const isMaster = JSON.parse(master);
    const [showDialog, setShowDialog] = useState(false);
    const [id, setId] = useState('');
    const [query, setQuery] = useState(q || '');
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [reason, setReason] = useState('');
    const [buyers, setBuyers] = useState(JSON.parse(params.buyers || '[]'));

    const handleDialogClose = () => setShowDialog(false);
    const onQueryChange = (e) => {
        setQuery(e.target.value);
        search(e.target.value);
    };
    const search = useCallback(debounce(async (q) => {
        window.history.replaceState({}, null, `${location.pathname}?q=${q}`);
        const res = await fetch(`${url}.json?q=${q}`, {headers: {...csrfHeader()}});
        const buyers = await res.json();
        setBuyers(buyers);
    }, 500), []);
    const onAddNgBuyer = async () => {
        await fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json', ...csrfHeader()}, body: JSON.stringify({id, name, address, phone, reason})});
        location.reload();
    };
    const onDelete = async buyer => {
        if (!confirm(`購入者ブラックリストから「${buyer.name}」を削除しますか？`)) {
            return;
        }
        await fetch(`${url}/${buyer.id}`, {method: 'DELETE', headers: csrfHeader()});
        location.reload();
    };
    console.log(buyers);

    const onEdit = buyer => {
        setId(buyer.id);
        setName(buyer.name);
        setAddress(buyer.address);
        setPhone(buyer.phone);
        setReason(buyer.reason);
        setShowDialog(true);
    };
    const onNew = () => {
        onEdit({});
    };

    return <>
        <div className="d-flex">
            <FormControl placeholder="購入者ブラックリストを検索"
                         onChange={onQueryChange}
                         value={query}
            />
            {
                isMaster &&
                <button className="btn btn-primary ml-4" style={{minWidth: '96px'}} onClick={onNew}>
                    <i className="fas fa-plus-circle mr-2"></i>
                    追加
                </button>
            }
        </div>
        <Modal
            show={showDialog}
            onHide={handleDialogClose}
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>購入者ブラックリストを追加</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormControl className="mb-2" value={name} onChange={e => setName(e.target.value)} placeholder="氏名" />
                <FormControl  className="mb-2" value={address} onChange={e => setAddress(e.target.value)} placeholder="住所" />
                <FormControl className="mb-2" value={phone} onChange={e => setPhone(e.target.value)} placeholder="電話番号" />
                <FormControl as="textarea" value={reason} onChange={e => setReason(e.target.value)} placeholder="理由"/>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleDialogClose}>
                    キャンセル
                </Button>
                <Button variant="primary" onClick={onAddNgBuyer}>追加</Button>
            </Modal.Footer>
        </Modal>
        <Table striped className="mt-4">
            <tbody>
            {
                buyers.map((buyer, i) => <tr key={`address-${i}`}>
                    <td>{buyer.id}</td>
                    <td>{buyer.name}</td>
                    <td>{buyer.address}</td>
                    <td>{buyer.phone}</td>
                    <td>{buyer.created_at}</td>
                    <td>
                        {
                            isMaster && <button className="btn btn-primary" onClick={() => onEdit(buyer)}>編集</button>
                        }
                    </td>
                    <td>{
                        isMaster && <button className="btn btn-danger" onClick={() => onDelete(buyer)}>削除</button>
                    }</td>
                </tr>)
            }
            </tbody>
        </Table>

    </>;
};